// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"184":"90c639f1babe6bef","337":"9fd726f2f955f8d8","842":"40e373a0e7e3617a"}[chunkId] + ".js";
};